/** @format */

import * as ROUTES from "../routes";

export const getVoucherUrl = (
  code: string | null | undefined,
  id: number | string | null | undefined,
): string => {
  if (!code || !id) return "";
  const prefix = String(code).toUpperCase();
  if (prefix.startsWith("PT"))
    return `${ROUTES.ACCOUNTING.CASH_RECEIPT_DETAIL}/${id}`;
  if (prefix.startsWith("PC"))
    return `${ROUTES.ACCOUNTING.CASH_PAYMENT_DETAIL}/${id}`;
  if (prefix.startsWith("BC"))
    return `${ROUTES.ACCOUNTING.BANK_RECEIPT_DETAIL}/${id}`;
  if (prefix.startsWith("BN"))
    return `${ROUTES.ACCOUNTING.BANK_PAYMENT_DETAIL}/${id}`;
  if (prefix.startsWith("PX") || prefix.startsWith("BH"))
    return `${ROUTES.ACCOUNTING.SALES_DOCUMENT_DETAIL}/${id}`;
  if (prefix.startsWith("PN") || prefix.startsWith("MH"))
    return `${ROUTES.ACCOUNTING.PURCHASE_DOCUMENT_DETAIL}/${id}`;
  if (prefix.startsWith("PK"))
    return `${ROUTES.ACCOUNTING.OTHER_DOCUMENT_DETAIL}/${id}`;
  return "";
};

export const formatDateSafe = (value?: string) => {
  if (!value) return "";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString("vi-VN");
};

export const compareDateFilter = (filterDate: Date, cellValue?: string) => {
  if (!cellValue) return -1;
  const cellDate = new Date(cellValue);
  if (Number.isNaN(cellDate.getTime())) return 1;
  const cellOnly = new Date(
    cellDate.getFullYear(),
    cellDate.getMonth(),
    cellDate.getDate(),
  );
  if (cellOnly < filterDate) return -1;
  if (cellOnly > filterDate) return 1;
  return 0;
};

export const parseNumberSafe = (value: unknown): number => {
  if (value === null || value === undefined || value === "") return 0;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const parsed = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : 0;
};

export const parseRateSafe = (value: unknown): number | undefined => {
  if (value === null || value === undefined || value === "") return undefined;
  const parsed = Number(String(value).replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : undefined;
};

export const formatCurrency = (value: unknown, isVND = true): string => {
  const num =
    typeof value === "number" && Number.isFinite(value)
      ? value
      : Number(String(value ?? "").replace(/,/g, ""));
  if (!Number.isFinite(num)) {
    return String(value ?? "");
  }
  const formatted = new Intl.NumberFormat("vi-VN", {
    style: "decimal",
    maximumFractionDigits: 0,
  }).format(num);
  return isVND ? `${formatted} ₫` : formatted;
};

/**
 * Format a plain number with thousand separators (no currency symbol).
 * Example: 153 -> "153"
 */
export const fmtNumber = (val: number | null | undefined): string => {
  const num = Number(val ?? 0);
  if (!Number.isFinite(num)) return "0";
  return new Intl.NumberFormat("vi-VN", {
    style: "decimal",
    maximumFractionDigits: 0,
  }).format(num);
};

export const normalizeDateInput = (value?: string | null): string => {
  if (!value) return "";
  const trimmed = String(value).trim();

  // Already in ISO-like format 2026-01-02 -> keep yyyy-mm-dd
  if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
    return trimmed.slice(0, 10);
  }

  // Native Date parseable (includes timezone or other ISO variants)
  const direct = new Date(trimmed);
  if (!Number.isNaN(direct.getTime())) {
    return direct.toISOString().slice(0, 10);
  }

  // Fallback for dd/mm/yyyy or yyyy/mm/dd (also accepts slashes or backslashes)
  const parts = trimmed.split(/[\\/]/);
  if (parts.length >= 3) {
    const [p1, p2, p3] = parts;
    const isYearFirst = p1.length === 4;
    const day = isYearFirst ? Number(p3) : Number(p1);
    const month = Number(p2) - 1;
    const rawYear = isYearFirst ? p1 : p3;
    const year =
      rawYear.length === 2 ? Number(`20${rawYear}`) : Number(rawYear);
    const parsed = new Date(year, month, day);
    if (!Number.isNaN(parsed.getTime())) {
      return parsed.toISOString().slice(0, 10);
    }
  }

  // Unrecognized format
  return "";
};
